import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup } from '~/commonComponents';
import { OutlineWarning01Icon } from '@tempmee/react-icons';

const WarningIconComponent = () => (
  <OutlineWarning01Icon width={80} height={80} color={colors.warning[500]} />
);

interface IRejectCandidateConfirmationPopupProps {
  isLoading: boolean;
  jobLocalDate: string;
  professionalName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeclineCandidateConfirmationPopup = ({
  isLoading,
  jobLocalDate,
  professionalName,
  onClose,
  onConfirm,
}: IRejectCandidateConfirmationPopupProps) => (
  <ConfirmPopup
    Icon={WarningIconComponent}
    title="Before You Continue"
    titleStyle={{ marginTop: 21, marginBottom: 20 }}
    description={
      <Typography as="span" color={colors.neutral[500]}>
        Are you sure you want to decline <Typography as="span" color={colors.neutral[500]}>{professionalName}</Typography>{' '}
        <br />
        for the interview on {jobLocalDate}?
        <br />
        If yes, click “Decline” to continue.
      </Typography>
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    leftButtonAction={onClose}
    leftButtonDisabled={isLoading}
    leftButtonText="Go Back"
    rightButtonAction={onConfirm}
    rightButtonLoading={isLoading}
    rightButtonText="Yes, Decline"
  />
);
